import { AccountType } from "@/services/user/types";

export enum ThirdPartyLoginStatus {
  // API response codes
  ok = 1,
  differentAccountType = 2,
  accountInactive = 3,
  wrongData = 4,
}

export enum LoginProvider {
  google = AccountType.google,
  facebook = AccountType.facebook,
}
